export const NAMESPACES = [
  'common',
  'errors',
  'auth',
  'payment',
  'utils',
  'admin',
  'adminTools',
  'animals',
  'kennel',
  'adoption',
  'profile',
  'chat',
  'features',
  'pawmatch',
  'landing',
  'about',
  'legal',
  'tutorial',
  'pricing',
  'blog',
  'advertiser',
  'onboarding',
  'ui',
  'courses',
  'contentReview',
] as const

export type Namespace = (typeof NAMESPACES)[number]

export const SUPPORTED_LANGUAGES = ['pt', 'en'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]
